import { useSelector } from 'react-redux';

import { USD } from '../../../../constants/currency-codes';
import { BillingPlanIds } from '../../../../enums/billing-plan-ids';
import Global from '../../../../store/global-selectors';

// TODO: this is being deprecated for Global.selectSellerSubscriptionCurrency, but here until the backend feature flag driving that property is on 100%
const useGetLikelySubscriptionCurrency = () => {
  const subscriptionData = useSelector(Global.selectSellerSubscriptionData);
  const { currentBillingPlan, allPlans = [] } = subscriptionData;

  // Can't trust trial plan currency data at the moment
  if (currentBillingPlan && currentBillingPlan.billingPlanId !== BillingPlanIds.Trial.toString() && currentBillingPlan.pricePerPeriod) {
    return currentBillingPlan.pricePerPeriod.code;
  }

  return allPlans?.[0]?.pricePerPeriod?.code;
};

/*
 *   Use this hook to not footgun yourself with the wrong currency code until individual billable item entities are trust worthy
 *   The currency code here is applicable to the plan subscription and billable items as a whole.
 */
export const useGetSubscriptionCurrencyCode = () => {
  const subscriptionCurrencyCode = useSelector(Global.selectSellerSubscriptionCurrency);
  const likelyCurrenyCode = useGetLikelySubscriptionCurrency();
  const defaultCurrencyCode = useSelector(Global.selectSellerDefaultCurrency);
  return subscriptionCurrencyCode || likelyCurrenyCode || defaultCurrencyCode || USD;
};
